export const acceptedSpreadsheetTypes = '.xlsx,.xls,.csv,.xlsm';
export const xlsFileTypes = '.xlsx,.xls,.xlsm';
export const xlsxOnly = '.xlsx';
export const supporting = 'Supporting';
export const main = 'Main';
export const unmapped = 'Unmapped';
export const newSupportingDocAfterPeriodCreation = 'NewSupportingDocAfterPeriodCreation';
